import React from "react";
import {BrowserRouter as Router, Route, Switch, useParams} from "react-router-dom";

import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "./App.css";
import {makeStyles} from '@material-ui/core/styles';
import WebPaymentForm from "./WebPaymentForm";
import SamaMoneyForm from "./SamaMoneyForm";

import cardImage from './paiement-cb.png'
import orangePay from './nfc-orange-pay.png'
import {Grid, Link} from "@material-ui/core";

function useQuery() {
    return new URLSearchParams(window.location.search);
}

const stripeKey = useQuery().get("publishable_key")
console.log('stripeKey', stripeKey);
// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with your real test publishable API key.
// "pk_test_51IPSn9LLLXo1NSInp1GBUQCiSElwm9ampRa2uFnUHVal0DCvrn0OV8HDrgE6vLkmyoF0bcdKrm1rC8lBmIR6ss8t008wKHgETw"
const promise = stripeKey ? loadStripe(stripeKey) : null;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
        },
    ],
};

function Home() {
    const token = useParams().token;
    return (
        <Grid container>
            {promise && <Grid item>
                <Link href={`/stripe/${token}?publishable_key=${stripeKey}`} component={"a"}>
                    <img src={cardImage} alt={"Stripe Payment"}/>
                </Link>
            </Grid>}
            <Grid item>
                <Link href={`/orange/${token}`} component={"a"}>
                    <img src={orangePay} alt={"Orange Payment"}/>
                </Link>
            </Grid>
        </Grid>
    )
}

export default function App() {
    const classes = useStyles();
    return (
        <Router>
            <div className={classes.root}>
                <Switch>
                    {promise && <Route path="/stripe/:token">
                        <Elements stripe={promise} options={ELEMENTS_OPTIONS}>
                            <CheckoutForm/>
                        </Elements>
                    </Route>}
                    <Route path={"/orange/:token"}>
                        <WebPaymentForm/>
                    </Route>
                    <Route path={"/samamoney/:token"}>
                        <SamaMoneyForm/>
                    </Route>
                    <Route path={"/:token"}>
                        <Home/>
                    </Route>
                    <div>
                        <a href={"/docs"}>Documentation Swagger</a>
                    </div>
                </Switch>
            </div>
        </Router>
    );
}
